var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ name: 'index' }}},[_c('p',{staticClass:"has-text-weight-bold is-size-5",domProps:{"innerHTML":_vm._s(_vm.name)}})])}
var staticRenderFns = []

export { render, staticRenderFns }